var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7171 21.2511C28.7171 22.6163 27.2921 24.0505 25.9176 24.0505H18.4523L15.6528 27.783L12.8534 24.0505H5.38809C4.01354 24.0505 2.58861 22.6163 2.58861 21.2511V5.38788C2.58861 4.02271 4.01354 2.58849 5.38809 2.58849H25.9176C27.2921 2.58849 28.7171 4.02271 28.7171 5.38788V21.2511ZM25.6069 0.722229H5.69884C2.95068 0.722229 0.72229 2.93468 0.72229 5.66502V21.4256C0.72229 24.1541 2.63993 25.9167 5.38809 25.9167H11.5833L15.6528 30.5833L19.7223 25.9167H25.9176C28.6658 25.9167 30.5834 24.1541 30.5834 21.4256V5.66502C30.5834 2.93468 28.355 0.722229 25.6069 0.722229Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.a0f801dc7130a6983ff4d7d04590a40f.svg";
export { ForwardRef as ReactComponent };